export const getIdFromUrl = parameterName => {
  const parse_url = window.location.pathname.split("/");
  let id = parse_url[parse_url.length - 1];

  if (window.location.search) {
    const idParam = findGetParameter(parameterName);
    if (idParam) {
      id = idParam;
    }
  }
  return {id, parse_url};
};

const findGetParameter = parameterName => {
  let result = null,
    tmp = [];
  window.location.search
    .substr(1)
    .split("&")
    .forEach(function(item) {
      tmp = item.split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
  return result;
};



// WEBPACK FOOTER //
// ./src/utils/url.js